module.exports = __webpack_public_path__ + "media/images/driving_in_portugal_center-d9cd5f1de75451cf78c9f01ac7bfd628.jpg";